import { Extension } from '@tiptap/core';
import { splitCell } from 'prosemirror-tables';

export const SplitTableCell = Extension.create({
  name: 'splitTableCell',

  addCommands() {
    return {
      // 拆分当前选中的单元格
      splitTableCell: () => ({ state, dispatch }) => {
        const { selection } = state;
        if (splitCell(state, dispatch)) {
          return true;
        }
        return false;
      },
    };
  },
});
